<template>
  <td>
    <h6 class="custom-margin-h6-table">
      <strong>{{ tdLabel }}</strong>
    </h6>
    <el-tag
      v-for="(item, index) in data"
      :key="index"
      :effect="effect"
      type="info"
      >{{ item[fieldTag] }}</el-tag
    >
    <el-tag v-if="data.length == 0" type="warning" :effect="effect">{{
      $t('common_words.no_assignment')
    }}</el-tag>
  </td>
</template>
<script>
export default {
  name: 'td-info-tag',
  props: {
    data: {
      type: Array,
      required: true,
    },
    tdLabel: {
      type: String,
      required: true,
    },
    fieldTag: {
      type: String,
      required: true,
    },
    effect: {
      type: String,
      default: 'plain',
    },
  },
};
</script>
